import { gql, useMutation } from '@apollo/client';
import { LINK_FIELDS } from "../../fragments";
export const CREATE_LINK = gql`
  ${LINK_FIELDS}
  mutation createLink($link: LinkCreateDtoInput) {
    link_create(link: $link) {
      ...LinkFields
    }
  }
`;
export const useLazyMutationCreateLink = onCompleteQuery => {
  return useMutation(CREATE_LINK, {
    errorPolicy: 'all',
    onCompleted({
      link_create
    }) {
      if (onCompleteQuery) {
        onCompleteQuery(link_create);
      }
    }
  });
};